export default __webpack_public_path__ + "static/294bd482eef0239d8a8af1eb81b68e59.png";